import React from "react"
import { useRenderStyling } from 'lib/hooks/useRenderStyling';
import { TrxDetailBlock, TrxDetailHeader, TrxDetailDataElement } from "."


export default function DetailScreenCCInfo({
  screen,
  renderPkg
}:{
  screen:any; 
  renderPkg?:any
}){

  const splitBlocksStyle = useRenderStyling("w-6/12 flex flex-col pl-4 pr-4 pt-0 pb-0", "styleObj")
  const blocksWrapperStyle = useRenderStyling("w-full flex gap-5", "styleObj")

  return (
    <TrxDetailBlock>
      <TrxDetailHeader title="Credit Card Information" />
      <div {...blocksWrapperStyle}>
        {/* left side  */}
        <div {...splitBlocksStyle}>
          <TrxDetailDataElement label="CC Number" value={screen.ccInfo.ccNumber} />
          <TrxDetailDataElement label="CC Type" value={screen.ccInfo.ccType} />
          <TrxDetailDataElement label="CVV Status" value={screen.ccInfo.cvvStatus} />
        </div>
        {/* right side  */}
        <div {...splitBlocksStyle}>
          <TrxDetailDataElement label="CC Expiration" value={screen.ccInfo.ccExp} />
          <TrxDetailDataElement label="AVS Status" value={screen.ccInfo.avsDescription()} />
          <TrxDetailDataElement label="Auth Code" value={screen.ccInfo.authCode} />
        </div>
      </div>
    </TrxDetailBlock>
  )
}